import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { RouteHelperService } from '../route-helper.service';
import { TokenStorageService } from 'src/app/shared/services/token-storage.service';

@Injectable()
export class RoleGuard {
  constructor(private readonly routeHelper: RouteHelperService, private readonly tokenStorage: TokenStorageService) {}

  public canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
    const roles = route.data.roles || route.parent.data.roles;
    const userInfo = this.tokenStorage.userInfo;

    if (!userInfo) {
      return false;
    }

    if (userInfo.IsSysAdmin) {
      return true;
    }

    if (!roles) {
      this.routeHelper.forbidden();
      return false;
    }

    const programRoles = roles.program;
    const siteRoles = roles.site;
    const systemRoles = roles.system;

    if (!systemRoles && !siteRoles && !programRoles) {
      return true;
    }

    if (programRoles && programRoles.some((x) => userInfo.CurrentProgramRoles.includes(x))) {
      return true;
    }

    if (siteRoles && siteRoles.some((x) => userInfo.CurrentSiteRoles.includes(x))) {
      return true;
    }

    if (systemRoles && systemRoles.some((x) => userInfo.SystemRoles.includes(x))) {
      return true;
    }

    this.routeHelper.forbidden();

    return false;
  }

  public canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.canActivate(childRoute, state);
  }
}
